import React, { ChangeEvent, FormEvent, useState } from "react";
import UniqueNameDropdown from "./UniqueNameDropdown";
import InputField from "components/fields/InputField";
import dataService from "service/dataService";
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dataservice from 'service/dataService';


interface StudentDetails {
  studentId?: string;
  firstName: string;
  lastName: string;
  fullName: string;
  hourlyRate: string [];
  email: string;
  grade: string;
  phoneNumber:string,
  major: string[];
  discount:number;
}

interface AddHoursProps {
  studentId?: string; 
  firstName: string;
  lastName: string;
  fullName: string;
  hourlyRate: string;
  email?: string;
  grade: string;
  major: string;
  hours:number;
  phoneNumber:string,
  selectedDate: Date | null;
  discount:number;
}

const AddHours = () => {
    const [formData, setFormData] = React.useState<StudentDetails>({
        studentId: '',
        firstName: '',
        lastName: '',
        fullName: '',
        hourlyRate: [],
        email: '',
        grade: '',
        phoneNumber: '',
        major: [],
        discount:0,
    });
 const [selectedMajorValue, setSelectedMajorValue] = useState<string>(''); // Initialize with an empty string or a default value
 const [selectedHourValue, setSelectedHourValue] =  useState<string>('');
 const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
 const [studentId, setStudentId] = useState<string>('');
 const [hour, setHour] = useState<number>();
 const [studentForm, setStudentForm] = useState<AddHoursProps>({
        studentId: '',
        firstName: '',
        lastName: '',
        fullName: '',
        hourlyRate: '',
        email: '',
        grade: '',
        major: '',
        hours: 0,
        phoneNumber: '',
        selectedDate: null,
        discount: 0,
    });
    const [showAlert, setShowAlert] = useState(false);
    const [discount, setDiscount] =useState<number>();

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        studentForm.major = selectedMajorValue;
        studentForm.hourlyRate = selectedHourValue;
        studentForm.selectedDate = selectedDate;
        studentForm.hours = hour;
        studentForm.studentId = studentId;
        studentForm.firstName = formData.firstName;
        studentForm.lastName = formData.lastName;
        studentForm.fullName = formData.fullName;
        studentForm.email = formData.email;
        studentForm.phoneNumber = formData.phoneNumber;
        studentForm.grade = formData.grade;
        studentForm.discount = discount;
        setStudentForm({
            ...studentForm,
            studentId: studentId,
            firstName: formData.firstName,
            lastName: formData.lastName,
            fullName: formData.fullName,
            hourlyRate: selectedHourValue,
            email: formData.email,
            grade: formData.grade,
            major: selectedMajorValue,
            hours: hour,
            phoneNumber: formData.phoneNumber,
            selectedDate: selectedDate,
            discount: discount
        });
        console.log(studentForm);

         dataservice.addDailyHoursData(studentForm).then(() => {
          setShowAlert(true);
          setTimeout(() => {
            setHour(0);
            setSelectedMajorValue('');
            setSelectedHourValue('');
            setDiscount(0);
            setShowAlert(false);
           // window.location.reload();
          }, 3000); // 3000 milliseconds = 3 seconds
        });

  
  
       /*  setTimeout(() => {
         // dataService.addDailyHoursData(studentForm).then(() => {
            setShowAlert(true);
            setTimeout(() => {
              window.location.reload();
            }, 3000); // 3000 milliseconds = 3 seconds
          }); */




        // Handle form submission logic here
    }

    function handleChange(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>): void {
        const { name, value } = event.target;
        
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
         setHour(Number(event.target.value));
        
    }

   const handleSelectMajorChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedMajorValue(event.target.value);
        console.log(event.target.value);

        // formData.major[0] = selectedMajorValue;
      };    


   const handleSelectHourChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedHourValue(event.target.value);
        console.log(event.target.value);
        // formData.major[0] = selectedMajorValue;
      };  
 

  const handleDiscount = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const value = event.target.value;
      setDiscount(Number(value));
    };  

  const handleNameSelection = (name: string) => {
    // setSelectedName(name);
    //console.log('Selected name:', name);
    
    dataService.getUsersByFullName(name).then((users) => {
        console.log('Users fetched for name', name, ':', users);
        const selectedMajor: string[] = users.map(user => user.major).flat();
        const selectedHours: string[] = users.map(user => user.hourlyRate).flat();
        const discountPer:number[] = users.map(user => user.discount).flat();
        console.log(discountPer);
        console.log(Math.max(...discountPer)+"discountPer");
        if (users.length > 0) {
         const user = users[0]; // Get the last user in the array
         console.log('Selected user details:', users[0].id);
         setStudentId(user.uid === '' ? user.id : user.uid);
         const uniqueHours = Array.from(new Set(selectedHours));
         const uniqueMajors = Array.from(new Set(selectedMajor));
         setDiscount(Math.max(...discountPer)); 
          setFormData({ 
            ...formData,
            firstName: user.firstName,
            hourlyRate: uniqueHours,
            lastName: user.lastName,
            fullName: user.fullName,
            email: user.email,
            phoneNumber:user.phoneNumber,
            grade: user.grade,
            major: uniqueMajors,
            discount:discount
          });  
          setHour(0);
          setSelectedMajorValue('');
          setSelectedHourValue('');
          console.log('User major data:', formData);
      }
    });
  };

  return (
    <div>

       {/* task header */}
      <div className="max-w-6xl mx-auto mt-1 p-6 bg-white shadow-lg rounded-lg">
           {/* Success Alert */}
        { showAlert && (
          <div id="alert-border-1" className="flex items-center p-4 mb-4 text-green-800 border-t-4 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-800 dark:border-green-800" role="alert">
          <svg className="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <div className="ms-3 text-sm font-medium">
              Hours added successfully
            </div>
          </div>
          )} 

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Use grid for a two-column layout on medium screens and up */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <UniqueNameDropdown onNameSelect={handleNameSelection} />
            
            <div className="flex flex-col">
             <label htmlFor="grade" className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
              Select Date
            </label>
            


          <ReactDatePicker
            selected={selectedDate}
            //showTimeSelect
            onChange={(date: Date | null) => setSelectedDate(date)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            // You can also use custom render functions for header, day, etc., to apply more fine-grained Tailwind styling
          />
          </div>
            <div className="flex flex-col">
           <label htmlFor="hours" className="text-sm text-navy-700 dark:text-white ml-3 font-bold">Total Hours</label>
              <input
        id="myNumberInput"
        type="number"
        placeholder="Eg 1.5"
        required={true}
        value={hour} // Bind the input's value to the state
        onChange={handleChange} // Handle changes with the defined function
        min="0" // Optional: Set a minimum value
        max="3" // Optional: Set a maximum value
        step="any" // Optional: Set the step for increment/decrement buttons
         className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      />
          </div>
           <div>
            <label htmlFor="grade" className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
              Grade
            </label>
            <select
              id="grade"
              name="grade"
              value={formData.grade}
              onChange={handleChange}
              required={true}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="">Select Grade</option>
              <option value="5">Grade 5</option>
              <option value="6">Grade 6</option>
              <option value="7">Grade 7</option>
              <option value="8">Grade 8</option>
              <option value="9">Grade 9</option>
              <option value="10">Grade 10</option>
              <option value="11">Grade 11</option>
              <option value="12">Grade 12</option>
            </select>
          </div>
        <div>
         <label htmlFor="Select the Major" className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
           Select the Major
        </label>  
       <select 
         className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" id="major-select"
         value={selectedMajorValue}
         required={true}
          onChange={handleSelectMajorChange}>
  
        <option value="">--Please choose an option--</option>
        
        {formData.major.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
     </div>

{/*           <InputField
            label="Major"
            value={formData.major}
            onchange={(e) => setFormData({ ...formData, major: e.target.value })}
            id={''} extra={''} placeholder={'eg: Precalculus'} variant={''}   
             required={true} 
          /> */}
      <div>
      <label
        htmlFor="hourlyRate"
        className={`text-sm text-navy-700 dark:text-white ml-3 font-bold`}
      >
        Hourly Rate
      </label>
    
      {/* Currency Input Field */}
        <select 
         className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" id="major-select"
         value={selectedHourValue}
         required={true}
          onChange={handleSelectHourChange}>
  
        <option value="">--Please choose an option--</option>
        {formData.hourlyRate.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
       {/*  <CurrencyInput
          id="hourlyRate"
          name="hourlyRate"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Eg: $45.00"
          defaultValue={formData.hourlyRate ? parseFloat(formData.hourlyRate) : undefined}
          decimalsLimit={2} // Limit to 2 decimal places
          prefix="$" // Add a currency prefix
          intlConfig={{ locale: 'en-US', currency: 'USD' }} // Specify locale and currency
          onValueChange={(value: string | undefined) => setFormData({ ...formData, hourlyRate: value || '' })}
          value={formData.hourlyRate}
          required
        /> */}
        </div>
        <div>
        <InputField
            label="Email Address"
            type="email"
            value={formData.email}
            onchange={(e) => setFormData({ ...formData, email: e.target.value })}
            id={''} extra={''} placeholder={'email@apex.com'} variant={''}  
            required={false}
            disabled
          />
        </div>
        <div>
         <InputField
            label="Phone Number"
            type="PhoneNumber"
            value={formData.phoneNumber}
            onchange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
            id={''} extra={''} placeholder={'(555) 555-5555'} variant={''}  
            required={false}
            disabled
          /> 
        </div>
         <div>
                  <label
        htmlFor="hourlyRate"
        className={`text-sm text-navy-700 dark:text-white ml-3 font-bold`}
      >
        Discount %
      </label>
          <select id="discount"
             value={discount}
           className="w-42 p-2 border bg-gray-50 rounded-md border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block "
           required onChange={handleDiscount}>
            <option selected>Select a Discount</option>
            <option value="0">0%</option>
            <option value="5">5%</option>
            <option value="10">10%</option>
            <option value="15">15%</option>
            <option value="20">20%</option>
            <option value="25">25%</option>
          </select>
   
       </div>  
        </div>

        {/* Submit Button */}
        <div className="flex justify-end mt-6">
          <button
            type="submit"
            className="px-4 py-2 bg-indigo-600 text-white font-semibold rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Save Details
          </button>
        </div>
      </form>
    </div>
 </div>
  );
};

export default AddHours;
